module.exports = __webpack_public_path__ + "img/kkts_long.8ecacab3.svg";